import React, { useContext, useRef, useState } from 'react'
import { AiOutlinePlus } from "react-icons/ai";
import { AiOutlineMinus } from "react-icons/ai";
import { Link, useNavigate } from 'react-router-dom';
import { Payout } from '../saldo/payout';
import Faq from './faq';
import { UserContext } from '../../../App';

const Bank = ({ error, setError }) => {

  const { auth, user, setUser } = useContext(UserContext)
  const token = localStorage.getItem('token')

  const navigate = useNavigate()

  return (
    <div id="bank" className="block lg:flex gap-8 space-y-8 lg:space-y-0">
      <div className="flex flex-col gap-2 h-full justify-between w-full flex-[1.5]">
        <div className="">
          <h2 className="text-base xl:text-lg font-medium">Udbetalingskonto</h2>
          <div className="text-sm xl:text-base">
            <h2 className="">Sikker håndtering af dine oplysninger via <span className="font-medium">Stripe</span>, vores betalingspartner.</h2>
          </div>
        </div>
        {(error !== '') ? <h2 className="text-sm font-medium text-red-500">{error}</h2> : ""}
        <Payout returnUrl={window.location.href} setError={setError} />
      </div>
    </div>
  )
}

export default Bank